import { cssClass } from '~src/style';

/**
 * The styles defined here match the previous angular login page css attributes.
 * Values are cherry-picked from login.styl
 */
export namespace LoginPageStyles {

  const cssPrefix = 'login-page';

  export const textboxStyle = cssClass(cssPrefix, 'text-box', {
    'textAlign': 'left',
    $nest: {
      'input': {
        height: '34px !important',
        lineHeight: '30px !important',
        width: '300px !important',
      },
    },
  });

  export const submitButtonStyle = cssClass(cssPrefix, 'submit-button', {
    minWidth: '224px !important',
    height: '48px !important',
    marginTop: '15px',
    padding: '6px !important',
    fontSize: '18px !important',
  });
}
